import { put, takeLatest } from "@redux-saga/core/effects";
import { Notification } from "components/Notification/Noti";
import _ from "lodash";

import { setShowLoadingScreen } from "redux/slices/global";

import { loadFieldsAPI } from "redux/api/objectsAPIs";

import {
  loadListExposeAPI,
  createExposeAPI,
  deleteExposeAPI,
  updateExposeAPI,
  getDetailsExposeAPI,
} from "redux/api/exposeAPIInteractionAPI";
import {
  loadListExposeAPII,
  loadListExposeAPIIResult,
  createExposeAPII,
  deleteExposeAPII,
  updateExposeAPII,
  getDetailsExposeAPII,
  getDetailsExposeAPIIResult,
  loadObjectFields,
  loadObjectFieldsResult,
  setShowModalSetting,
  getDetailsPayload,
  getDetailsPayloadResult,
  setShowModalPayload,
  loadAllFieldsResult,
} from "redux/slices/exposeAPIInteraction";

export default function* exposeAPIInteraction() {
  yield takeLatest(loadListExposeAPII.type, LoadListExposeAPII);
  yield takeLatest(loadObjectFields.type, LoadObjectFields);
  yield takeLatest(createExposeAPII.type, CreateExposeAPII);
  yield takeLatest(updateExposeAPII.type, UpdateExposeAPII);
  yield takeLatest(getDetailsExposeAPII.type, GetDetailsExposeAPII);
  yield takeLatest(deleteExposeAPII.type, DeleteExposeAPII);
  yield takeLatest(getDetailsPayload.type, GetDetailsPayload);
}

function* LoadListExposeAPII() {
  try {
    yield put(setShowLoadingScreen(true));
    const response = yield loadListExposeAPI();
    yield put(loadListExposeAPIIResult(response.data.data));
    yield put(setShowLoadingScreen(false));
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* LoadObjectFields(action) {
  try {
    const handleFields = (response) => {
      let tempFieldsMain = [];
      let tempFieldsAll = [];

      _.get(response, "data.data", []).forEach((item) => {
        if (
          Object.values(item)[0] !== null &&
          (Object.values(item)[0].readable || Object.values(item)[0].writeable)
        ) {
          if (Object.keys(item)[0] === "main_object") {
            Object.values(item)[0].sections.forEach((ele) => {
              ele.fields.forEach((field) => {
                if (field.permission_hidden === false) {
                  if (
                    field.type === "linkingobject" &&
                    _.get(field, "is_indexed", false)
                  ) {
                    tempFieldsMain.push({
                      label: field.related_name,
                      value: field.full_field_id,
                      type: field.type,
                      required: field.required,
                      is_indexed: _.get(field, "is_indexed", false),
                    });
                  } else {
                    tempFieldsMain.push({
                      label: field.related_name,
                      value: field.full_field_id,
                      type: field.type,
                      required: field.required,
                      is_indexed: _.get(field, "is_indexed", false),
                    });
                  }
                }
              });
            });
          }

          Object.values(item)[0].sections.forEach((ele) => {
            ele.fields.forEach((field) => {
              if (
                field.permission_hidden === false &&
                _.get(field, "is_indexed", false)
              ) {
                tempFieldsAll.push({
                  label: field.related_name,
                  value: field.full_field_id,
                  type: field.type,
                  required: field.required,
                  is_indexed: _.get(field, "is_indexed", false),
                });
              }
            });
          });
        }
      });

      return {
        tempFieldsMain: tempFieldsMain,
        tempFieldsAll: tempFieldsAll,
      };
    };

    if (action.payload.object_id === "init") {
      const response1 = yield loadFieldsAPI({
        api_version: "2",
        object_id: "obj_interaction_00000001",
      });
      yield put(
        loadObjectFieldsResult({
          obj_interaction_00000001: handleFields(response1).tempFieldsMain,
        })
      );
      yield put(
        loadAllFieldsResult({
          obj_interaction_00000001: handleFields(response1).tempFieldsAll,
        })
      );

      const response2 = yield loadFieldsAPI({
        api_version: "2",
        object_id: "obj_contact_00000001",
      });
      yield put(
        loadObjectFieldsResult({
          obj_contact_00000001: handleFields(response2).tempFieldsMain,
        })
      );
      yield put(
        loadAllFieldsResult({
          obj_contact_00000001: handleFields(response2).tempFieldsAll,
        })
      );
      const response3 = yield loadFieldsAPI({
        api_version: "2",
        object_id: "obj_lead_00000001",
      });
      yield put(
        loadObjectFieldsResult({
          obj_lead_00000001: handleFields(response3).tempFieldsMain,
        })
      );
      yield put(
        loadAllFieldsResult({
          obj_lead_00000001: handleFields(response3).tempFieldsAll,
        })
      );
      const response4 = yield loadFieldsAPI({
        api_version: "2",
        object_id: "obj_ticket_00000001",
      });
      yield put(
        loadObjectFieldsResult({
          obj_ticket_00000001: handleFields(response4).tempFieldsMain,
        })
      );
      yield put(
        loadAllFieldsResult({
          obj_ticket_00000001: handleFields(response4).tempFieldsAll,
        })
      );
    } else {
      const response = yield loadFieldsAPI(action.payload);

      yield put(
        loadObjectFieldsResult({
          [action.payload.object_id]: handleFields(response).tempFieldsMain,
        })
      );
      yield put(
        loadAllFieldsResult({
          [action.payload.object_id]: handleFields(response).tempFieldsAll,
        })
      );
    }
  } catch (error) {}
}

function* CreateExposeAPII(action) {
  try {
    yield put(setShowLoadingScreen(true));
    yield createExposeAPI(action.payload);
    yield put(setShowLoadingScreen(false));
    yield put(setShowModalSetting(false));
    Notification("success", "Create successfully!");
    yield put(loadListExposeAPII());
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* UpdateExposeAPII(action) {
  try {
    yield put(setShowLoadingScreen(true));
    yield updateExposeAPI(action.payload);
    yield put(setShowLoadingScreen(false));
    yield put(setShowModalSetting(false));
    Notification("success", "Update successfully!");
    yield put(loadListExposeAPII());
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* DeleteExposeAPII(action) {
  try {
    yield put(setShowLoadingScreen(true));
    yield deleteExposeAPI(action.payload);
    yield put(setShowLoadingScreen(false));
    Notification("success", "Delete successfully!");
    yield put(loadListExposeAPII());
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* GetDetailsExposeAPII(action) {
  try {
    yield put(setShowLoadingScreen(true));
    const response = yield getDetailsExposeAPI(action.payload);
    yield put(getDetailsExposeAPIIResult(response.data.data));
    yield put(setShowLoadingScreen(false));
    yield put(setShowModalSetting(true));
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* GetDetailsPayload(action) {
  try {
    yield put(setShowLoadingScreen(true));
    const response = yield getDetailsExposeAPI(action.payload);
    yield put(getDetailsPayloadResult(response.data.data));
    yield put(setShowLoadingScreen(false));
    yield put(setShowModalPayload(true));
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}
